<template>
    <template v-if="editing === 'sorting'">
        <div class="edit sorting-widget">
            <span class="material-symbols-outlined icon">swap_vert</span>
            <select
                id="list-sort"
                v-model="sortColumn"
                @change="onSortColumnChange($event)"
            >
                <option :value="null">Default</option>
                <option
                    v-for="column in columns"
                    :key="column[0]"
                    :value="column[0]"
                >
                    {{ column[1] }}
                </option>
            </select>
            <label>
                <input
                    id="list-direction"
                    v-model="reversed"
                    type="checkbox"
                    @change="
                        $emit(
                            'update',
                            'reversed',
                            $event.target.checked || null
                        )
                    "
                />
                Reversed
            </label>
        </div>
    </template>
    <template v-if="editing === ''">
        <div v-if="sortColumn" class="sorting-active">
            <span class="material-symbols-outlined icon">sort</span>
            {{ columnNames[sortColumn] }} {{ getDirection }}
        </div>
    </template>
</template>
<script>
export default {
    name: "SortingWidget",
    props: {
        editing: {
            type: String,
            required: true,
        },
        columns: {
            type: Array,
            required: true,
        },
        query: {
            type: Object,
            required: true,
        },
    },
    emits: ["update"],
    data() {
        return {
            columnNames: {},
            sortColumn: null,
            reversed: false,
        };
    },
    computed: {
        getDirection() {
            return this.reversed ? "⬇" : "⬆";
        },
    },
    mounted() {
        this.sortColumn = this.query.sort || null;
        this.reversed = !!this.query.reversed;
        this.columnNames = Object.fromEntries(this.columns);
    },
    methods: {
        onSortColumnChange(event) {
            let value = event.target.value;
            this.$emit("update", "sort", value === "Default" ? null : value);
        },
    },
};
</script>
